import React, { useState, useEffect, useRef } from 'react';
import TR from '../../Trans';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import AlbumIcon from '@mui/icons-material/Album';
import Paper from '@mui/material/Paper';
import FormGroup from '@mui/material/FormGroup';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import InfoIcon from '@mui/icons-material/Info';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import CreatorsDialog from './CreatorsDialog';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DialogContent from '@mui/material/DialogContent';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MuvikaService from './../../services/muvika';
import IconButton from '@mui/material/IconButton';
import PitchButtons from '../items/PitchButtons';
import FormControl from '@mui/material/FormControl';
import accountStore from '../../stores/account';
import AddSinger from './../dialogs/AddSinger';
import InputLabel from '@mui/material/InputLabel';
import messageStore from './../../stores/message';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import sessionStore from './../../stores/session';
import bgSearchStore from '../../stores/bgSearch';
import navigationStore from '../../stores/navigation';
import Link from '@mui/material/Link';
import { Views } from './../../enums/enums';

function BackgroundMusicChangeTrackPerformance(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const setError = messageStore((state) => state.setError);

  const itemsOnPage = 25;
  const setSearchQuery = bgSearchStore((state) => state.setSearchQuery);
  const goToView = navigationStore((state) => state.goToView);
  const search = bgSearchStore((state) => state.search);
  const setOnlyArtist = bgSearchStore((state) => state.setOnlyArtist);

  const [creators, setCreators] = useState(null);

  useEffect(() => {
    getCreators();
  }, []);

  const getCreators = () => {
    if (props.track) {
      if (props.track.track_id) {
        MuvikaService.getTrackCreators(sessionToken, props.track.track_id)
          .then(function (res) {
            if (res.data.data) {
              if (res.data.error) {
                setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              } else {
                setCreators(res.data.data.items);
              }
            }
          })
          .catch(function () { });
      }
    }
  };

  const [isCreatorsDialogOpen, setIsCreatorsDialogOpen] = useState(false);

  const handleOpenCreatorsDialog = () => {
    getCreators();
    setIsCreatorsDialogOpen(true);
  };

  const handleCloseCreatorsDialog = () => {
    setIsCreatorsDialogOpen(false);
  };

  const changeTrackPerformance = () => {
    props.onChangeTrackPerformance();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (isCreatorsDialogOpen) {
        handleCloseCreatorsDialog();
      } else {
        changeTrackPerformance();
      }
    }
  };

  const handleSearchArtist = () => {
    props.onClose();
    setOnlyArtist();
    setSearchQuery(props.track.artist);
    search(sessionToken, itemsOnPage);
    goToView(Views.BackgroundMusicSearch);
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <CreatorsDialog open={isCreatorsDialogOpen} onClose={handleCloseCreatorsDialog} creators={creators} track={props.track} />
      <DialogContent>
        <div className="muvika-cover-music-image">
          <AlbumIcon />
        </div>
        <h4 className="muvika-track-title">
          <Link className="muvika-link-nodec" onClick={handleSearchArtist}>
            {props.track.artist}
          </Link> - {props.track.title} ({props.track.kcode})
          <IconButton color="white" component="label" onClick={handleOpenCreatorsDialog}>
            <InfoIcon />
          </IconButton>
        </h4>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={changeTrackPerformance}>{TR.cm_change}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default BackgroundMusicChangeTrackPerformance;